import styled from 'styled-components/native';

export const Container = styled.View`
  padding: 0.5rem 0rem;
`;
